import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AiOutlineShoppingCart, AiOutlineUser, AiOutlineHistory} from "react-icons/ai";
import { IoMdLogOut } from "react-icons/io";
import { logoutUser } from "../../../store/thunks";
import { clearCart } from "../../../store/cartSlice";

const routes = [
    { to: "/login",         name: "Sign In", auth: false, },
    { to: "/register",      name: "Sign Up", auth: false, },
    { to: "/order/history", name: "orders",  auth: true,  },
    { to: "/cart",          name: "cart",    auth: true,  },
    { to: "/profile",       name: "profile", auth: true,  },
    { to: "/logout",        name: "logout",  auth: true,  },
];

const NavItem = ({ mobile }) => {

    const isAuth = useSelector((state) => state.user?.isAuth);
    const isAdmin = useSelector((state) => state.user?.isAdmin);
    const cartItems = useSelector((state) => state.cart.items);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const uniqueItemsCount = cartItems.length;
    const handleLogout = () => {
        dispatch(logoutUser()).then(() => {
            dispatch(clearCart());
            navigate("/login");
        });
    };
    return (
        <ul
            className={`text-md justify-center w-full flex gap-4 ${
                mobile && "flex-col bg-gray-900 h-full"
            } items-center`}
        >
            {routes.map(({ to, name, auth, icon }) => {
                if (isAuth !== auth) return null;
                if ( to === "/logout") {
                    return (
                        <li
                            key={name}
                            className="py-2 text-center cursor-pointer"
                        >
                            <IoMdLogOut onClick={handleLogout} />
                        </li>
                    );
                }
                if (!isAdmin && to === "/cart") {
                    return (
                        <li
                            key={name}
                            className="relative py-2 text-center cursor-pointer"
                        >
                            <Link to={to}>
                                <AiOutlineShoppingCart style={{ fontSize: "1.4rem" }} />
                                <span className="absolute -top-1 -right-1 bg-red-600 text-white rounded-full h-5 w-5 flex items-center justify-center text-xs">
                                    {uniqueItemsCount || 0 }
                                </span>
                            </Link>
                        </li>
                    );
                }
                if (!isAdmin && to === "/profile") {
                    return (
                        <li
                            key={name}
                            className="py-2 text-center cursor-pointer"
                        >
                            <Link to={to}>
                                <AiOutlineUser style={{ fontSize: "1.4rem" }} />
                            </Link>
                        </li>
                    );
                }
                if (!isAdmin && to === "/order/history") {
                return (
                    <li key={name} className="py-2 text-center cursor-pointer">
                                <Link to={to}>
                                    <AiOutlineHistory style={{ fontSize: "1.4rem" }} />
                                </Link>
                            </li>
                        );
                }
                if (!isAuth) {
                    return (
                        <li
                            key={name}
                            className="py-2 text-center cursor-pointer"
                        >
                            <Link to={to}>{name}</Link>
                        </li>
                    );
                }
                return null;
            })}
        </ul>
    );
};

export default NavItem;
